webpackJsonp([1],{

/***/ "/sJd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LKPp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('h1', [_vm._v("Elo Calculator")]), _vm._v(" "), _c('h2', [_vm._v("Calculate your new rating")]), _vm._v(" "), _c('div', {
    staticClass: "myStats"
  }, [_c('label', {
    attrs: {
      "for": "rating"
    }
  }, [_vm._v("Current rating")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.myRating),
      expression: "myRating"
    }],
    attrs: {
      "type": "number",
      "id": "rating",
      "min": "0",
      "max": "4000",
      "placeholder": "Rating"
    },
    domProps: {
      "value": (_vm.myRating)
    },
    on: {
      "change": function($event) {
        _vm.saveValues()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.myRating = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating"
    }
  }, [_vm._v("Score")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.score),
      expression: "score"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "step": "0.5",
      "max": this.opponents.length,
      "placeholder": "Score"
    },
    domProps: {
      "value": (_vm.score)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.score = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating"
    }
  }, [_vm._v("K-factor")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kFactor),
      expression: "kFactor"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.kFactor = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("10")]), _vm._v(" "), _c('option', [_vm._v("20")]), _vm._v(" "), _c('option', [_vm._v("30")]), _vm._v(" "), _c('option', [_vm._v("40")])])]), _vm._v(" "), _c('form', {
    staticClass: "addOpponent",
    on: {
      "submit": _vm.addOpponent
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newOpponent.rating),
      expression: "newOpponent.rating"
    }],
    staticClass: "addOpponent",
    attrs: {
      "type": "number",
      "min": "800",
      "max": "3000",
      "placeholder": "Add new opponent rating"
    },
    domProps: {
      "value": (_vm.newOpponent.rating)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newOpponent.rating = $event.target.value
      }
    }
  })]), _vm._v(" "), (this.opponents.length > 0) ? _c('div', {
    staticClass: "opponents"
  }, [_c('table', [_vm._m(0), _vm._v(" "), _vm._l((_vm.opponents), function(opponent) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(opponent.rating))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(opponent.expectation.toFixed(2)))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn opponent-remove",
      on: {
        "click": function($event) {
          _vm.removeOpponent(opponent)
        }
      }
    }, [_c('i', [_vm._v("×")])])])])
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "margin-bottom": "10px"
    },
    on: {
      "click": function($event) {
        _vm.clearOpponents()
      }
    }
  }, [_vm._v("\n        Clear opponents\n      ")])]) : _vm._e(), _vm._v(" "), (this.myRating > 800 && this.myRating <= 3000) ? _c('div', {
    staticClass: "results"
  }, [_c('h2', [_vm._v("Expected result")]), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.totalExpectation.toFixed(2)) + "\n    ")]), _vm._v(" "), _c('h2', [_vm._v("New rating")]), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.newRating.toFixed(1)) + " \n      "), (_vm.newRating - this.myRating >= 0) ? _c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("(+" + _vm._s((_vm.newRating - this.myRating).toFixed(1)) + ")")]) : _vm._e(), _vm._v(" "), (_vm.newRating - this.myRating < 0) ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("(" + _vm._s((_vm.newRating - this.myRating).toFixed(1)) + ")")]) : _vm._e()])]) : _vm._e()])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Rating")]), _vm._v(" "), _c('th', [_vm._v("Expected result")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bf1da34_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("ilX3");
function injectStyle (ssrContext) {
  __webpack_require__("vRyE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bf1da34_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "N2i+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h1', [_vm._v("About")]), _vm._v(" "), _c('p', [_vm._v("Welcome to elocalculator.com! This is a quick website I built to learn more about VueJS. Hope you find it useful!")]), _vm._v(" "), _c('p', [_vm._v("To find more information about my chess applications, go to "), _c('a', {
    attrs: {
      "href": "https://darksquaregames.com"
    }
  }, [_vm._v("darksquaregames.com")]), _vm._v(" or check out all my iOS apps at "), _c('a', {
    attrs: {
      "href": "https://itunes.apple.com/developer/id878126674"
    }
  }, [_vm._v("https://itunes.apple.com/developer/id878126674")])]), _vm._v(" "), _c('p', [_vm._v("In order to find other great chess resources, visit "), _c('a', {
    attrs: {
      "href": "https://chessfort.com"
    }
  }, [_vm._v("chessfort.com")])]), _vm._v(" "), _c('p', [_vm._v("Elo Calculator is also available at the  iOS App Store")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "display": "inline-block",
      "overflow": "hidden",
      "background": "url(//linkmaker.itunes.apple.com/assets/shared/badges/en-us/appstore-lrg.svg) no-repeat",
      "width": "135px",
      "height": "40px",
      "background-size": "contain"
    },
    attrs: {
      "href": "https://itunes.apple.com/us/app/elo-calculator-calculate-your-new-chess-rating/id1000600209?mt=8"
    }
  })])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__dirname) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Opponents__ = __webpack_require__("dTLV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_About__ = __webpack_require__("c27y");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
	mode: 'history',
	base: __dirname,
	routes: [{ path: '/', component: __WEBPACK_IMPORTED_MODULE_3__components_Opponents__["a" /* default */] }, { path: '/about', component: __WEBPACK_IMPORTED_MODULE_4__components_About__["a" /* default */] }]
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
	router: router,
	template: '<div id="app"> \n  \t\t\t\t<div class="menu">\n\t\t\t\t\t<router-link to="/">Calculator</router-link>\n\t\t\t\t\t<router-link to="/about">About</router-link>\n\t\t\t\t</div>\n\t\t\t<router-view></router-view>\n\t\t</div>\n\t\t'
}).$mount('#app');
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "/"))

/***/ }),

/***/ "c27y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37413a1f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__("N2i+");
function injectStyle (ssrContext) {
  __webpack_require__("/sJd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37413a1f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dTLV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Opponents_vue__ = __webpack_require__("o/NI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6391d7c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Opponents_vue__ = __webpack_require__("LKPp");
function injectStyle (ssrContext) {
  __webpack_require__("ewpa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Opponents_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6391d7c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Opponents_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ewpa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ilX3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('opponents')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "o/NI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_elo_rating__ = __webpack_require__("oluJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_elo_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_elo_rating__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var OPPONENT_STORAGE_KEY = 'elo-storage';
var MY_RATING_STORAGE_KEY = 'my-rating-storage';
var K_FACTOR_STORAGE_KEY = 'k-factor-storage';
var SCORE_STORAGE_KEY = 'score-storage';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'opponents',
  data: function data() {
    return {
      myRating: 2000,
      kFactor: 30,
      score: 0,
      newOpponent: {},
      opponents: []
    };
  },
  created: function created() {
    this.score = JSON.parse(localStorage.getItem(SCORE_STORAGE_KEY) || 0);
    this.myRating = JSON.parse(localStorage.getItem(MY_RATING_STORAGE_KEY) || 2000);
    this.kFactor = JSON.parse(localStorage.getItem(K_FACTOR_STORAGE_KEY) || 30);
    this.opponents = JSON.parse(localStorage.getItem(OPPONENT_STORAGE_KEY) || '[]');
  },

  computed: {
    totalExpectation: function totalExpectation() {
      var total = 0;
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(this.opponents).forEach(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            opponent = _ref2[1];

        total += opponent.expectation;
      });
      return total;
    },
    newRating: function newRating() {
      if (this.myRating >= 800 && this.myRating <= 3000) {
        return Number(this.myRating) + (this.score - this.totalExpectation) * this.kFactor;
      }
    }
  },
  methods: {
    saveValues: function saveValues() {
      var _this = this;

      console.log("save values");
      localStorage.setItem(SCORE_STORAGE_KEY, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.score));
      localStorage.setItem(MY_RATING_STORAGE_KEY, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.myRating));
      localStorage.setItem(K_FACTOR_STORAGE_KEY, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.kFactor));
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(this.opponents).forEach(function (_ref3) {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
            key = _ref4[0],
            opponent = _ref4[1];

        opponent.expectation = __WEBPACK_IMPORTED_MODULE_3_elo_rating___default.a.expected(_this.myRating, opponent.rating);
      });
      localStorage.setItem(OPPONENT_STORAGE_KEY, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.opponents));
    },
    clearOpponents: function clearOpponents() {
      this.opponents = [];
      localStorage.setItem(OPPONENT_STORAGE_KEY, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.opponents));
      this.score = 0;
      this.saveValues();
    },
    addOpponent: function addOpponent(e) {
      this.opponents.push({
        rating: this.newOpponent.rating,
        expectation: __WEBPACK_IMPORTED_MODULE_3_elo_rating___default.a.expected(this.myRating, this.newOpponent.rating)
      });
      console.log(__WEBPACK_IMPORTED_MODULE_3_elo_rating___default.a.expected(this.myRating, this.newOpponent.rating));
      localStorage.setItem(OPPONENT_STORAGE_KEY, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.opponents));
      this.newOpponent.rating = "";
      e.preventDefault();
      this.saveValues();
    },
    removeOpponent: function removeOpponent(opponent) {
      this.opponents.splice(this.opponents.indexOf(opponent), 1);
      localStorage.setItem(OPPONENT_STORAGE_KEY, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.opponents));
      if (this.score > this.opponents.length) {
        this.score = this.opponents.length;
      }
      this.saveValues();
    }
  }
});

/***/ }),

/***/ "vRyE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Opponents__ = __webpack_require__("dTLV");
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    Opponents: __WEBPACK_IMPORTED_MODULE_0__components_Opponents__["a" /* default */]
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.89e8e59cfdeff304f543.js